import { NgModule } from '@angular/core';
import {
  SuperPipeToFixedFormat,
  SuperPipeToLVFormat,
  SuperPipeMomentFormat,
  SuperPipeSizeFormat,
  SuperPipeLengthFormat,
  SuperPipeUcFirst,
  SuperPipeGetKeys,
} from './format.pipe';
import { ArraySortPipe, ReversePipe } from './sorts.pipe';
import { FilterByKeyValue, SearchByValue, SearchByKeyValue, minDate, maxDate, FilterByObject, findArrayFilter } from './filter.pipe';
import { ReturnFirst, ReturnLast, ReturnWithout } from "./array.pipe";

@NgModule({
  declarations: [
    ArraySortPipe,
    ReversePipe,
    FilterByKeyValue,
    SearchByValue,
    SearchByKeyValue,
    minDate,
    maxDate,
    FilterByObject,
    ReturnFirst,
    ReturnLast,
    ReturnWithout,
    findArrayFilter,
    SuperPipeToFixedFormat,
    SuperPipeToLVFormat,
    SuperPipeMomentFormat,
    SuperPipeSizeFormat,
    SuperPipeLengthFormat,
    SuperPipeUcFirst,
    SuperPipeGetKeys,
  ],
  imports: [

  ],
  exports: [
    ArraySortPipe,
    ReversePipe,
    FilterByKeyValue,
    SearchByValue,
    SearchByKeyValue,
    minDate,
    maxDate,
    FilterByObject,
    ReturnFirst,
    ReturnLast,
    ReturnWithout,
    findArrayFilter,
    SuperPipeToFixedFormat,
    SuperPipeToLVFormat,
    SuperPipeMomentFormat,
    SuperPipeSizeFormat,
    SuperPipeLengthFormat,
    SuperPipeUcFirst,
    SuperPipeGetKeys,
  ],
  providers: [

  ],
  entryComponents: [

  ]
})
export class SuperPipesModule { }
